import React from "react";
import { View, Text, StyleSheet, Linking } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { Color, globalStyle } from "../assets";
import FastImage from "../common/FastImage";
import { globalConfigurableData } from "../utils/globalConstant";

const WeHaveMovedScreen = () => {
    const styles = StyleSheet.create({
        container: {
            flex: 1,
            paddingHorizontal: 16,
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
        },
        text: {
            textAlign: "center",
            marginTop: 16,
        },
        link: {
            color: "blue",
            textDecorationLine: "underline",
        },
    });

    return (
        <SafeAreaView style={styles.container}>
            <FastImage
                style={{
                    height: 30,
                    width: 80,
                }}
                source={globalConfigurableData?.logoUrl()}
            />
            <Text style={[globalStyle.headerBlue, styles.text]}>We've Moved!</Text>

            <Text style={styles.text}>
                Service Discontinued in India
                {" "}
            </Text>

            <Text style={styles.text}>
                Thank you for being part of the TradeX journey. We're shifting from a real-money gaming platform to a free-to-play, casual social gaming experience, and have discontinued real money opinion trading services in India.
            </Text>

            <Text style={[styles.text, { marginTop: 32 }]}>
                For reporting any issue or withdrawing any remaining funds, please contact{" "}
                <Text
                    style={styles.link}
                    onPress={() => Linking.openURL("mailto:support@tradexapp.co")}
                >
                    support@tradexapp.co
                </Text>
                {" "}
                <View style={{ width: '100%', alignItems: 'center' }}>
                    <Text style={styles.text}>
                        or
                    </Text>
                </View>
                {" "}
                <Text
                    style={[styles.link, { marginTop: 32 }]}
                    onPress={() =>
                        Linking.openURL(
                            "https://support.tradexapp.co/portal/en/newticket?departmentId=128151000000010772"
                        )
                    }
                >
                    Raise a ticket via Help Center
                </Text>
            </Text>

            {/* <Text style={styles.text}>
                To withdraw your existing funds, please contact support at{" "}
                <Text
                    style={styles.link}
                    onPress={() => Linking.openURL("mailto:support@tradexapp.co")}
                >
                    support@tradexapp.co
                </Text>
            </Text> */}
        </SafeAreaView>
    );
};

export default WeHaveMovedScreen;
